const homeUrls = {
    mainStats: '/applications/stats/mainStats',
    agentStats: '/applications/stats/agentStats',
    clientStats: '/applications/stats/clientStats',
    companyStats: '/applications/stats/companyStats',

};

export default homeUrls;